import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";

const WarehouseTransactionMaster = () => {
  const tableHeaders = [
    "#",
    "Product",
    "Variant",
    "Old Qty",
    "New Qty",
    "Difference Qty",
    "Unit Cost",
    "Total Cost",
    "Remarks",
    "Action",
  ];

  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [allVariantData, setAllVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();

  const adjustment_id = localStorage.getItem("adjustment_id");

  const [formData, setFormData] = useState({
    id: null,
    adjustment_id: adjustment_id,
    sa_variant_master_id: "",
    warehouse_product_master_id: "",
    old_qty: "",
    new_qty: "",
    difference_qty: "",
    unit_cost: "",
    total_cost: "",
    remarks: "",
  });

  const [transactionDetails, setTransactionDetails] = useState({});

  useEffect(() => {
    fetchData();
    fetchProductData();
    fetchVariantData();
    const details = {
      adjustment_id: localStorage.getItem("adjustment_id"),
      adjustment_type: localStorage.getItem("adjustment_type"),
      reason_type: Number(localStorage.getItem("reason_type")),
      total_value: localStorage.getItem("total_value"),
    };
    setTransactionDetails(details);
  }, []);

 const getLabel = (options, value) => {
  const found = options.find(opt => opt.value === Number(value));
  return found ? found.label : value;
};

  const adjustmentTypeOptions = [
  { value: 1, label: "INCREASE" },
  { value: 2, label: "DECREASE" },
];

const reasonTypeOptions = [
  { value: 1, label: "ADJUSTMENT" },
  { value: 2, label: "DAMAGE" },
  { value: 3, label: "WASTAGE" },
  { value: 4, label: "EXPIRY" },
];

 const fetchData = async () => {
  try {
    setInitialLoading(true);
    const res = await axios.get(
      `${var_api}veemart_wh_inventory_adjustment_details/getByAdjustmentId/${adjustment_id}`
    );

    const list =
      Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

    setData(list);
  } catch (err) {
    toast.error("Failed to fetch data");
  } finally {
    setInitialLoading(false);
  }
};


  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setProductData(allProducts);
    } catch (err) {
      toast.error("Failed to fetch product data");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const allData = res.data || [];
      setAllVariantData(allData);
      setVariantData(allData);
    } catch (err) {
      toast.error("Failed to fetch variant data");
    }
  };

  const handleSelectChange = (selected, name) => {
    const value = selected ? selected.value : "";
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    if (name === "warehouse_product_master_id") {
      const filteredVariants = allVariantData.filter(
        (v) => String(v.product_id) === String(value)
      );
      setVariantData(filteredVariants);
      setFormData((prev) => ({ ...prev, sa_variant_master_id: "" }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAdd = () => {
    setFormData({
      id: null,
      adjustment_id: adjustment_id,
      sa_variant_master_id: "",
      warehouse_product_master_id: "",
      old_qty: "",
      new_qty: "",
      difference_qty: "",
      unit_cost: "",
      total_cost: "",
      remarks: "",
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.warehouse_product_master_id)
      newErrors.warehouse_product_master_id = "Product is required";
    if (!formData.sa_variant_master_id)
      newErrors.sa_variant_master_id = "Variant is required";
    if (!formData.new_qty) newErrors.new_qty = "New Quantity is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fix the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode) {
        res = await axios.put(
          `${var_api}veemart_wh_inventory_adjustment_details/update/${formData.id}`,
          formData
        );
      } else {
        res = await axios.post(
          `${var_api}veemart_wh_inventory_adjustment_details/post`,
          formData
        );
      }
      toast.success(res?.data?.message || "Saved successfully");
      setShowModal(false);
      fetchData();
    } catch (err) {
      toast.error("Failed to save record");
    } finally {
      setLoading(false);
    }
  };

 const filteredData = data.filter((item) => {
  const productName =
    productData.find((p) => String(p.id) === String(item.warehouse_product_master_id))
      ?.product_name || "";

  const variantName =
    allVariantData.find((v) => String(v.id) === String(item.sa_variant_master_id))
      ?.variant_name || "";

  const combinedString = `
    ${productName}
    ${variantName}
    ${item.old_qty}
    ${item.new_qty}
    ${item.difference_qty}
    ${item.unit_cost}
    ${item.total_cost}
    ${item.remarks}
  `.toLowerCase();

  return combinedString.includes(searchQuery.toLowerCase());
});


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Card className="p-3 mb-3 position-relative">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Warehouse Adjustment Details</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => navigate("/inventory-adjustment")}
              >
                <i className="fas fa-arrow-left me-2"></i> Back to Transactions
              </Button>
            </div>
            <Row className="g-3">
              <Col xs="auto">
                <strong>Total:</strong>{" "}
                <span style={{ color: "green", fontWeight: "600" }}>
                  {(transactionDetails.total_value)}
                </span>
              </Col>
              <Col xs="auto">
                <strong>Adjustment Type:</strong>{" "}
                <span style={{ color: "green", fontWeight: "600" }}>
                  {getLabel(adjustmentTypeOptions, transactionDetails.adjustment_type)}
                </span>
              </Col>
                <Col xs="auto">
                <strong>Reason Type:</strong>{" "}
                <span style={{ color: "green", fontWeight: "600" }}>
                  {getLabel(reasonTypeOptions, transactionDetails.reason_type)}
                </span>
              </Col>
            </Row>
          </Card>

          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button variant="secondary" onClick={handleAdd}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      {tableHeaders.map((h, i) => (
                        <th key={i}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center text-muted py-3">
                          No records found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                           <td>
  {
    productData.find((p) => String(p.id) === String(item.warehouse_product_master_id))
      ?.product_name || "-"
  }
</td>
<td>
  {
    allVariantData.find((v) => String(v.id) === String(item.sa_variant_master_id))
      ?.variant_name || "-"
  }
</td>
                          <td>{item.old_qty}</td>
                          <td>{item.new_qty}</td>
                          <td>{item.difference_qty}</td>
                          <td>{item.unit_cost}</td>
                          <td>{item.total_cost}</td>
                          <td>{item.remarks}</td>
                          <td>
                            <button
                              className="btn shadow btn-xs sharp"
                              style={{
                                backgroundColor: "#007bff",
                                color: "white",
                              }}
                              onClick={() => handleEdit(item)}
                              title="Edit"
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      className="me-1"
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Adjustment" : "Add Adjustment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              {/* Product Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Product <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={productData.map((p) => ({
                      label: p.product_name,
                      value: p.id,
                    }))}
                    value={
                      formData.warehouse_product_master_id
                        ? {
                            label:
                              productData.find(
                                (p) => p.id === formData.warehouse_product_master_id
                              )?.product_name || "Select Product",
                            value: formData.warehouse_product_master_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "warehouse_product_master_id")
                    }
                  />
                  {errors.warehouse_product_master_id && (
                    <div className="text-danger small mt-1">
                      {errors.warehouse_product_master_id}
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* Variant Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Variant <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={variantData.map((v) => ({
                      label: v.variant_name,
                      value: v.id,
                    }))}
                    value={
                      formData.sa_variant_master_id
                        ? {
                            label:
                              variantData.find(
                                (v) => v.id === formData.sa_variant_master_id
                              )?.variant_name || "Select Variant",
                            value: formData.sa_variant_master_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "sa_variant_master_id")
                    }
                  />
                  {errors.sa_variant_master_id && (
                    <div className="text-danger small mt-1">
                      {errors.sa_variant_master_id}
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* Quantities */}
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Old Qty</Form.Label>
                  <Form.Control
                    type="number"
                    name="old_qty"
                    min="1"
                    placeholder="Enter Old Qty"
                    value={formData.old_qty}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>New Qty</Form.Label>
                  <Form.Control
                    type="number"
                    name="new_qty"
                     min="1"
                    placeholder="Enter New Qty"
                    value={formData.new_qty}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Difference Qty</Form.Label>
                  <Form.Control
                    type="number"
                    name="difference_qty"
                     min="1"
                    placeholder="Enter Diff Qty"
                    value={formData.difference_qty}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Unit Cost</Form.Label>
                  <Form.Control
                    type="number"
                    name="unit_cost"
                     min="1"
                    placeholder="Enter Unit Cost"
                    value={formData.unit_cost}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Cost</Form.Label>
                  <Form.Control
                    type="number"
                    name="total_cost"
                     min="1"
                    placeholder="Enter  Total Cost"
                    value={formData.total_cost}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="remarks"
                    placeholder="Enter  Remarks"
                    value={formData.remarks}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2">
              {!isEditMode ? (
                <>
                  <Button variant="secondary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Creating...
                      </>
                    ) : (
                      "Create"
                    )}
                  </Button>
                  <Button
                    variant="danger"
                    type="reset"
                    disabled={loading}
                    onClick={() =>
                      setFormData({
                        id: null,
                        adjustment_id: adjustment_id,
                        sa_variant_master_id: "",
                        warehouse_product_master_id: "",
                        old_qty: "",
                        new_qty: "",
                        difference_qty: "",
                        unit_cost: "",
                        total_cost: "",
                        remarks: "",
                      })
                    }
                  >
                    Reset
                  </Button>
                </>
              ) : (
                <>
                  <Button variant="warning" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Updating...
                      </>
                    ) : (
                      "Update"
                    )}
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => setShowModal(false)}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default WarehouseTransactionMaster;
